import { defineStore } from "pinia";
import { ref } from "vue";
import { api } from "../lib/api";

const STORAGE_KEY = "isypos:preferences";

interface SavedPreferences {
  itemsPerPage: number;
  requestTimeoutSeconds: number;
  autoRefresh: boolean;
  autoRefreshSeconds: number;
  notifications: boolean;
  showSensitive: boolean;
}

export const usePreferencesStore = defineStore("preferences", () => {
  const itemsPerPage = ref(25);
  const requestTimeoutSeconds = ref(15);
  const autoRefresh = ref(false);
  const autoRefreshSeconds = ref(60);
  const notifications = ref(true);
  const showSensitive = ref(false);

  function persist() {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        itemsPerPage: itemsPerPage.value,
        requestTimeoutSeconds: requestTimeoutSeconds.value,
        autoRefresh: autoRefresh.value,
        autoRefreshSeconds: autoRefreshSeconds.value,
        notifications: notifications.value,
        showSensitive: showSensitive.value,
      } satisfies SavedPreferences),
    );
    api.defaults.timeout = requestTimeoutSeconds.value * 1000;
  }

  function initialize() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}") as Partial<SavedPreferences>;
      if ([10, 25, 50, 100].includes(saved.itemsPerPage ?? 0)) {
        itemsPerPage.value = saved.itemsPerPage!;
      }
      if ((saved.requestTimeoutSeconds ?? 0) > 0) {
        requestTimeoutSeconds.value = saved.requestTimeoutSeconds!;
      }
      autoRefresh.value = saved.autoRefresh ?? false;
      autoRefreshSeconds.value = saved.autoRefreshSeconds ?? 60;
      notifications.value = saved.notifications ?? true;
      showSensitive.value = saved.showSensitive ?? false;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
    api.defaults.timeout = requestTimeoutSeconds.value * 1000;
  }

  return {
    itemsPerPage,
    requestTimeoutSeconds,
    autoRefresh,
    autoRefreshSeconds,
    notifications,
    showSensitive,
    initialize,
    persist,
  };
});
